import { useQuery } from "@tanstack/react-query"
import { ApplicationGet } from "../app/models/Application"
import { AccessLevel } from "../app/models/Authorization"
import { digitalManagerApi } from "../services/api"

export function useApplications(
  featureShortName?: string,
  minAccessLevel = AccessLevel.Read
) {
  function buildUrl() {
    const params = new URLSearchParams()
    params.set("minAccessLevel", String(minAccessLevel))

    if (featureShortName) {
      params.set("feature", featureShortName)
    }

    return `/applications?${params.toString()}`
  }

  const { data: applicationsList = [], isLoading: isLoadingApplications } = useQuery({
    queryKey: ["applications", featureShortName, minAccessLevel],
    queryFn: () =>
      digitalManagerApi.get<ApplicationGet[]>(buildUrl()).then((r) => r.data),
  })

  return {
    applicationsList,
    isLoadingApplications,
  }
}
